'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _raceSafe2 = require('../func/raceSafe');

var _raceSafe3 = _interopRequireDefault(_raceSafe2);

var _reactMixin = require('./reactMixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var _valueLink2 = require('./valueLink');

var _valueLink3 = _interopRequireDefault(_valueLink2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var BaseComponent = function (_Component) {
  _inherits(BaseComponent, _Component);

  function BaseComponent(props) {
    _classCallCheck(this, BaseComponent);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BaseComponent).call(this, props));

    _this.state = {};
    _this.__windowEventListeners = [];
    _this.__timers = [];
    _this.__raceSafeStorage = {};
    _this.__autoBind();
    return _this;
  }

  _createClass(BaseComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      // 移除全局事件监听器
      this.__windowEventListeners.forEach(function (args) {
        var _window;

        return (_window = window).removeEventListener.apply(_window, _toConsumableArray(args));
      });

      // 销毁定时器
      this.__timers.forEach(function (timer) {
        return clearTimeout(timer);
      });

      // 清空竞态安全的调用计数（组件被卸载时忽略未结束的异步操作）
      this.__raceSafeStorage = {};
    }

    /**
     * 对组件实例上的一个方法使用修饰器
     * @param {string} method 被修饰方法的名字
     * @param {function} decorator 使用的修饰器
     */

  }, {
    key: 'decorate',
    value: function decorate(method, decorator) {
      this[method] = decorator(this[method]) || this[method];
    }

    /**
     * Promise 模式的 React#setState
     * @param {object} newState 传给 React#setState 的参数
     * @returns {Promise|Promise<T>} 返回的 Promise 会在 setState 的 callback 被调用时完成
     */

  }, {
    key: 'setStateAsync',
    value: function setStateAsync(newState) {
      var _this2 = this;

      return new Promise(function (resolve) {
        return _this2.setState(newState, resolve);
      });
    }

    /**
     * 生成包括 props.className 的 CSS 类名
     * @param args classnames 库支持的参数
     */

  }, {
    key: 'classNames',
    value: function classNames() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _classnames2.default.apply(undefined, [this.props.className].concat(args));
    }

    /**
     * 添加一个全局的事件监听器，并在组件被卸载时移除它，参数与 window.addEventListener 相同
     */

  }, {
    key: 'windowEventListener',
    value: function windowEventListener(type, listener, useCapture) {
      var _window2;

      (_window2 = window).addEventListener.apply(_window2, arguments);
      this.__windowEventListeners.push(arguments);
    }

    /**
     * 创建一个定时器，并在组件被卸载时销毁它，参数和返回值与 window.setTimeout 相同
     */

  }, {
    key: 'setTimeout',
    value: function (_setTimeout) {
      function setTimeout(_x) {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function (func) {
      var delay = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];

      for (var _len2 = arguments.length, params = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        params[_key2 - 2] = arguments[_key2];
      }

      this.__timers.push(setTimeout.apply(undefined, [func, delay].concat(params)));
      return this.__timers[this.__timers.length - 1];
    })

    /**
     * 使一个回调函数或一个 Promise 在竞态条件下安全
     * 即对于相同名字的回调／Promise，无论被调用／解决的时间早晚，只有最后一次传递给此函数的会生效
     */

  }, {
    key: 'raceSafe',
    value: function raceSafe(callbackOrPromise) {
      var name = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

      return (0, _raceSafe3.default)(callbackOrPromise, name, this.__raceSafeStorage);
    }

    /**
     * 如果之前的 raceSafe 还未结束，取消它
     */

  }, {
    key: 'raceSafeCancel',
    value: function raceSafeCancel(name) {
      this.raceSafe(function () {}, name);
    }

    /**
     * 已废弃，待移除
     */

  }, {
    key: 'valueLink',
    value: function valueLink() {
      console.warn('this.valueLink 已弃用，请尽快迁移至 M.valueLink');

      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _valueLink3.default.apply(undefined, [this].concat(args));
    }

    /**
     * 绑定所有自定义方法的 this 到当前实例
     * @private
     */

  }, {
    key: '__autoBind',
    value: function __autoBind() {
      var prototype = this.constructor.prototype;

      while (prototype !== BaseComponent.prototype) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.getOwnPropertyNames(prototype)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var k = _step.value;

            var v = this[k];
            if (typeof v === 'function' && emptyObject[k] === undefined) {
              this[k] = v.bind(this);
              this[k].unbound = v;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        prototype = Object.getPrototypeOf(prototype);
      }
    }
  }]);

  return BaseComponent;
}(_react.Component);

var emptyObject = {};

BaseComponent.Mixin = _reactMixin2.default;

exports.default = BaseComponent;